import axios from '@axios'

export default {
  namespaced: true,
  state: {
    users: [],
  },
  getters: {
    GET_USERS: state => {
        return state.users
    }
  },
  mutations: {
    SET_USERS(state, payload) {
        state.users = payload
    }
  },
  actions: {
    fetchUsers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/users', { params: queryParams })
          .then(response => {
            ctx.commit('SET_USERS', response.data.users.map(user => {
                return {
                    ...user,
                    role: user.grupo.grupousuario,
                    ativo: user.ativo ? 'Ativo' : 'Inativo',
                }
            }))
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchGrups() {
      return new Promise((resolve, reject) => {
        axios
          .get('/groups')
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
    },
    fetchUser(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/users/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addUser(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/users', {
            ...userData,
            aprovado: 'Aprovado',
          })
          .then(response => resolve(response))
          .catch(error => {
            reject(error)
          })
      })
    },
    updatedUser(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/users/${userData.id}`, {
            ...userData,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchPadrinhoByUserId(ctx, userId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`padrinho/usuario/${userId}`)
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
    },
  },
}
